import { PROFILE_PATH } from '~/types/profileNavigationConfig';
import { AuthFormNames } from '~/models/FormNames';
import { setupPortalSession } from '@modules/portal/utils/setupUserSession';

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) {
    return;
  }

  // // Setup user session only once
  await callOnce('portal-session', async () => {
    await setupPortalSession();

    // Get cart data
    const { locale } = useNuxtApp().$i18n;
    useTimeout(500, { callback: async () => await useCartStore().getCartMeta(locale.value) });
  });

  if (to.path.includes(PROFILE_PATH.PROFILE)) {
    const userStore = useUserStore();
    const { locale } = useNuxtApp().$i18n;
    const { isLoggedIn } = storeToRefs(userStore);
    if (!(isLoggedIn.value)) {
      return navigateTo({
        path: `/${locale.value}/`,
        hash: `#${AuthFormNames.Login}`,
      });
    }
  }
});
